import { capitalizeFirstLetter } from '../capitalizeFirstLetter';

export const galleryTypes = {
    multimedia: 'multimediagallery',
    other: 'othergallery',
};

export const getChosenGallery = multimediaItem =>
    multimediaItem.multimediagallery ? galleryTypes.multimedia : galleryTypes.other;

export const getCategoryBasedGallery = (multimediaItem, category) =>
    multimediaItem?.multimediagallery ? category : `other${capitalizeFirstLetter(category)}`;
